export default __webpack_public_path__ + "static/media/yoga2.cc36fea3.png";